import { render, staticRenderFns } from "./GroupCompaniesFilter.vue?vue&type=template&id=1897f9e7&scoped=true&"
import script from "./GroupCompaniesFilter.vue?vue&type=script&lang=js&"
export * from "./GroupCompaniesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1897f9e7",
  null
  
)

export default component.exports